module.exports = __webpack_public_path__ + "media/images/common/drafl_prj-7ec42987f6e02b6a562081710a5be289.png";